import { FC } from 'react';
import moment from 'moment';

import { i18n as I18n } from 'utils/i18n';
import { formatDate, dateFormatForAPI, dateFormatForUI } from 'utils/date';

import { CCG_BOOKING_RESTRICTION } from 'constants/bookings';

interface Props {
  today?: string;
  date: string;
  setDate?: (date: string) => void;
}

const Header: FC<Props> = ({ today, date, setDate }) => {
  const prevDay = () =>
    setDate && moment(today).startOf('day').isBefore(date, 'day')
      ? setDate(formatDate(moment(date).subtract(1, 'days'), dateFormatForAPI))
      : undefined;

  const nextDay = () =>
    setDate &&
    moment(today).add(CCG_BOOKING_RESTRICTION, 'months').isAfter(date, 'day')
      ? setDate(formatDate(moment(date).add(1, 'days'), dateFormatForAPI))
      : undefined;

  return (
    <div className="calendar__date_header">
      {setDate && (
        <button
          type="button"
          className="button button--small"
          onClick={prevDay}
          title={I18n.t('venue_calendar.prev_day_title')}
        >
          <i className="fas fa-angle-double-left icon--right-margin" />
          {I18n.t('venue_calendar.prev_day')}
        </button>
      )}
      <span>{formatDate(date, dateFormatForUI)}</span>
      {setDate && (
        <button
          type="button"
          className="button button--small"
          onClick={nextDay}
          title={I18n.t('venue_calendar.next_day_title')}
        >
          {I18n.t('venue_calendar.next_day')}
          <i className="fas fa-angle-double-right icon--left-margin" />
        </button>
      )}
    </div>
  );
};

export default Header;
